import React from "react";
import "./maincards.css";

function WmCards(props) {
  return (
    <div className="cards" {...props}>
      {props.children}
    </div>
  );
}

export default WmCards;
